import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowBlockDown = function ArrowBlockDown(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 3.8c0-.28 0-.42.0545-.527a.5.5 0 0 1 .2185-.2185C9.38 3 9.52 3 9.8 3h4.4c.28 0 .42 0 .527.0545a.5.5 0 0 1 .2185.2185C15 3.38 15 3.52 15 3.8V14h4l-7 7-7-7h4z"
    })
  }));
};
export default ArrowBlockDown;